<script>
export default {
  name: "profileImageSection"
};
</script>

<template>
  <el-row style="padding: 10px 0 10px 0; background-color: #ffffff">
    <el-col
      :span="24"
      style="display: flex; justify-content: flex-start; padding: 0 10px;"
    >
      <span class="search-text" style="z-index: 11">My Account</span>
    </el-col>
  </el-row>
</template>

<style scoped>
.search-text {
  color: #003333;
  text-align: center;
  font-family: DINosaur-a, sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/components/profileImageSection.vue